/**
 * Application Constants
 * Centralized location for all application constants
 */

// API Endpoints Base
export const API_BASE_URL = process.env.REACT_APP_HR_API || 'http://localhost:8080/api';
export const IMG_BASE_URL = process.env.REACT_APP_IMG_URL || 'http://localhost:8080/';
export const HRMS_URL = process.env.REACT_APP_CT_HRMS_APP || 'http://localhost/';

// Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER_ID: 'userID',
  USER_NAME: 'userName',
  EMPLOYEE_NAME: 'employeeName',
  ROLE_NAME: 'roleName',
  EMAIL: 'emailID',
  LAST_INTERACTION: 'lastInteractionTime'
};

// Date Formats
export const DATE_FORMATS = {
  DISPLAY: 'MMM dd, yyyy',
  API: 'yyyy-MM-dd',
  DISPLAY_WITH_TIME: 'MMM dd, yyyy hh:mm a',
  API_WITH_TIME: 'yyyy-MM-dd HH:mm:ss'
};

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100]
};

// File Upload
export const FILE_UPLOAD = {
  MAX_SIZE_MB: 10,
  ALLOWED_TYPES: {
    IMAGES: ['.jpg', '.jpeg', '.png', '.gif'],
    DOCUMENTS: ['.pdf', '.doc', '.docx'],
    EXCEL: ['.xlsx', '.xls', '.csv'],
    RESUME: ['.pdf', '.doc', '.docx']
  }
};

// Candidate Status
export const CANDIDATE_STATUS = {
  NEW: 'New',
  SCREENING: 'Screening',
  INTERVIEW: 'Interview',
  SELECTED: 'Selected',
  REJECTED: 'Rejected',
  ON_HOLD: 'On Hold'
};

// Demand Status
export const DEMAND_STATUS = {
  OPEN: 'Open',
  IN_PROGRESS: 'In Progress',
  CLOSED: 'Closed',
  ON_HOLD: 'On Hold',
  CANCELLED: 'Cancelled'
};

// User Roles
export const USER_ROLES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  RECRUITER: 'Recruiter',
  TL: 'TL',
  SPOC: 'SPOC',
  HR: 'HR',
  PMO: 'PMO',
  MANAGER: 'Manager'
};

// Toast Messages
export const TOAST_MESSAGES = {
  SUCCESS: {
    CREATE: 'Created successfully',
    UPDATE: 'Updated successfully',
    DELETE: 'Deleted successfully',
    SAVE: 'Saved successfully'
  },
  ERROR: {
    GENERIC: 'Something went wrong. Please try again.',
    NETWORK: 'Network error. Please check your connection.',
    UNAUTHORIZED: 'You are not authorized to perform this action.',
    NOT_FOUND: 'Resource not found.',
    VALIDATION: 'Please check all required fields.'
  }
};

// API Timeout
export const API_TIMEOUT = 120000; // 120 seconds (2 minutes) - increased for slow queries

// Idle Timeout
export const IDLE_TIMEOUT_MINUTES = 30;

// Regex Patterns
export const REGEX_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^[0-9]{10}$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  ALPHANUMERIC: /^[a-zA-Z0-9]+$/
};

// Validation Messages
export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  INVALID_PHONE: 'Please enter a valid 10-digit phone number',
  INVALID_PASSWORD: 'Password must be at least 8 characters with uppercase, lowercase, number and special character',
  MIN_LENGTH: (length) => `Minimum ${length} characters required`,
  MAX_LENGTH: (length) => `Maximum ${length} characters allowed`
};

